export const RESPONSIVE_FLUID_CLASSNAME = 'timesgrid-fluid';

export const ZD_DIRECTORY_ID = '-1';
export const ZD_TEST_DIRECTORY_ID = '-2';

export function ServerException({
    errorCode,
    response,
    bookingState,
    errorFields,
    message,
    type,
    code,
}) {
    this.errorCode = errorCode;
    this.response = response;
    this.bookingState = bookingState;
    this.errorFields = errorFields;
    this.message = message;
    this.type = type;
    this.code = code;
}

/**
 * @typedef {int} INSURANCE_TYPE
 */

/**
 * @typedef {string} DEVICE_TYPE
 */

/**
 * @type {Object.<string, INSURANCE_TYPE>} INSURANCE_TYPES
 */
export const INSURANCE_TYPES = {
    DENTAL: 1,
    HEALTH: 2,
    VISION: 3,
};

/**
 * @type {Object.<string, int>} PROVIDER_STATUS
 */
export const PROVIDER_STATUS = {
    NEW_APPLICATION: 1,
    APPROVED_APPLICATION: 2,
    DELETED: 4,
    RESOURCE: 5,
    LOCKED: 60,
    CHURNED: 61,
};

/**
 * @type {Object.<string, DEVICE_TYPE>} DEVICE_TYPES
 */
export const DEVICE_TYPES = {
    ANDROID: 'Android',
    IOS: 'iOS',
};

/**
 * @type {Object.<DEVICE_TYPE, string>} USER_AGENTS
 */
export const USER_AGENTS = {
    [DEVICE_TYPES.ANDROID]:
        'Mozilla/5.0 (Linux; Android 8.1.0; Pixel Build/OPM1.171019.012) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/64.0.3282.137 Mobile Safari/537.36',
    [DEVICE_TYPES.IOS]:
        'Mozilla/5.0 (iPhone; CPU iPhone OS 5_0 like Mac OS X) AppleWebKit/534.46 (KHTML, like Gecko) Version/5.1 Mobile/9A334 Safari/7534.48.3',
};
